if (!customElements.get('boss-selling-plan')) {
  customElements.define(
    'boss-selling-plan',
    class BossSellingPlan extends HTMLElement {
      connectedCallback() {
        this.enforceConfiguration();

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;

          const source = event.data.html.getElementById(`BossSellingPlan-${event.data.sectionId}`);
          if (!source) return;

          this.dataset.required = source.dataset.required;
          this.dataset.valid = source.dataset.valid;
          this.className = source.className;
          this.innerHTML = source.innerHTML;
          this.enforceConfiguration();
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      enforceConfiguration() {
        if (this.dataset.required !== 'true' || this.dataset.valid === 'true') return;

        const productForm = this.closest('product-form');
        productForm?.toggleSubmitButton(true, 'Subscription unavailable');
      }
    }
  );
}
